import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { SubscriptionModal } from '@/components/subscription/SubscriptionModal';
import Navigation from "@/components/Navigation";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/toaster";

export function AppLayout({ children }: { children: React.ReactNode }) {
  const { user, profile } = useAuth();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  useEffect(() => {
    if (user && profile) {
      const trialEndDate = new Date(profile.subscription_expires_at || '');
      const now = new Date();

      // Show modal if trial has ended and user doesn't have an active subscription
      if (trialEndDate < now && profile.subscription_status !== 'active') {
        setShowSubscriptionModal(true);
      }
    }
  }, [user, profile]);

  return (
    <>
      <Navigation />
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <div className="min-h-screen bg-background">
          {children}
        </div>
      </ThemeProvider>
      <Toaster />
      <SubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
      />
    </>
  );
}